(ns app.front.view.group.admin.import.property
  (:require [app.domain.import.model :as import-model]
            [app.front.ui.radio :as ui-radio]
            [app.front.view.group.admin.import.common :as import-session-common]
            [app.front.view.group.admin.import.subs :as import-subs]
            [clojure.string :as str]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [re-frame.core-instrumented :as rf]))

(defmethod import-session-common/entities-cols :import-session.type/property [_]
  (let [tr (<sub [::import-session-common/property-tr])]
    [[(tr [:property/id]) :property/id]]))

(defmethod import-session-common/entity-href :import-session.type/property [_ property]
  (href/href :view/property {:db-id (:db/id property)}))

(defmethod import-session-common/mapping-settings :data-import.mapping/location-center-x [props]
  (let [{:keys [settings session-id target group-id ix tr]} props]
    [ui-radio/radio
     {:name       (str group-id "-data-import-" ix)
      :values     import-model/valid-coordinate-reference-systems
      :value      (:coordinate-format settings)
      :label-text (tr [:data-import/select-location-crs])
      :val->str   str/upper-case
      :on-change  (fn [e]
                    (>evt [::import-subs/set-mapping-debounce
                           {:authority-group-id group-id
                            :session-id         session-id
                            :col-ix             ix
                            :mapping-key        target
                            :settings           {:coordinate-format e}}]))
      :disabled   (not (<sub [::import-subs/is-draft? session-id]))}]))

(rf/reg-sub ::selectable-property-states
  (fn [_]
    [:property.state/active :property.state/historical]))

(defmethod import-session-common/mapping-settings :data-import.mapping/property-state [props]
  [(import-session-common/string-to-value-mapping-settings :data-import.mapping/property-state
                                                           ::selectable-property-states
                                                           identity
                                                           identity)
   props])

(rf/reg-sub ::selectable-parent-relationship-types
  (fn [_]
    [:property-relationship/subdivision :property-relationship/merge]))

(defmethod import-session-common/mapping-settings :property/parent-relationship-type [props]
  [(import-session-common/string-to-value-mapping-settings :property/parent-relationship-type
                                                           ::selectable-parent-relationship-types
                                                           identity
                                                           identity)
   props])
